import styled from "styled-components";

export const ScContainerWide = styled.div`
  padding: 16px 0 0 28px;
`;
